export default __webpack_public_path__ + "static/media/whale-watching.31511645.svg";